import Chip, { ChipProps } from '@mui/material/Chip'
import { memo } from 'react'

import { formatWithoutCents } from '@src/lib/Utils'

interface FundingChipProps extends Omit<ChipProps, 'label'> {
  amountInCents: number
}

const FundingChip: React.FC<React.PropsWithChildren<FundingChipProps>> = ({
  amountInCents: amountCents,
  ...chipProps
}) => {
  return (
    <Chip {...chipProps} label={formatWithoutCents.format(amountCents / 100)} />
  )
}

export default memo(FundingChip)
